import { classNames } from '@vkontakte/vkjs';
import { Tappable, TappableProps } from '@vkontakte/vkui';
import React from 'react';
import { MAX_ATTACH_HEIGHT_PX } from './const';
import styles from './MessageBubbleAttachImage.module.css';

interface MessageBubbleAttachImageProps extends React.HTMLAttributes<HTMLDivElement> {
  src: string;
  blurSrc?: string;
  overlay?: React.ReactNode;
  width?: number;
  height?: number;
  imageClassName?: string;
}

export function MessageBubbleAttachImage(props: MessageBubbleAttachImageProps) {
  const { src, onClick, className, overlay, blurSrc, width, height, imageClassName, ...rest } = props;

  const tappableProps: TappableProps = {
    hoverMode: 'opacity',
    activeMode: 'opacity',
    tabIndex: 0,
    role: 'button',
    style: {
      '--background': blurSrc ? `url(${blurSrc})` : 'none',
      aspectRatio: `${width} / ${height}`,
      maxHeight: MAX_ATTACH_HEIGHT_PX,
      height: '100%',
      width: '100%',
    } as React.CSSProperties,
  };

  return (
    <Tappable data-testid="attach-photo" className={classNames(styles.root, className)} {...tappableProps} {...rest}>
      <img src={src} alt="" className={classNames(styles.img, imageClassName)} onClick={onClick} />
      {overlay}
    </Tappable>
  );
}
